export interface Article {
  slug: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  coverImage: string;
  publishedAt: string;
  readCount: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: '2024-summer-photobook-release',
    title: '三上悠亚2024夏季写真集《夏の記憶》正式发售',
    summary: '三上悠亚全新夏季写真集《夏の記憶》于今日正式发售，收录了大量在冲绳拍摄的绝美写真，展现了阳光、沙滩与偶像的完美结合。',
    content: `<p>日本知名偶像三上悠亚的全新夏季写真集《夏の記憶》（夏の記憶）于今日正式在日本全国各大书店及线上平台同步发售。这部写真集是在冲绳取景拍摄，历时三周完成。</p>
<p>写真集共收录了超过120张精美写真，涵盖了海滩、泳池、和风旅馆等多个场景。三上悠亚在采访中表示："这是我有史以来最投入的一次拍摄，冲绳的碧海蓝天给了我很多灵感，希望大家能感受到夏日的活力与美好。"</p>
<p>值得一提的是，本次写真集还附赠了一张特别制作的幕后花絮DVD，记录了拍摄过程中的有趣瞬间和三上悠亚的独家访谈内容。限量版还包含了亲笔签名照片，粉丝们可要抓紧时间入手了。</p>
<p>发售首日，东京涩谷的TSUTAYA书店便排起了长队，不少粉丝一大早便前来抢购。书店方面表示，首批到货的500册在开售后两小时内便全部售罄，正在紧急补货中。</p>
<h3>写真集详情</h3>
<ul>
<li>标题：《夏の記憶》</li>
<li>摄影：小林伸一郎</li>
<li>页数：128页</li>
<li>定价：3,300日元（含税）</li>
<li>发售日期：2024年7月15日</li>
</ul>`,
    category: 'photo-gallery',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20idol%20on%20sunny%20Okinawa%20beach%20with%20white%20sand%20and%20turquoise%20ocean%2C%20flowing%20white%20dress%2C%20soft%20natural%20lighting%2C%20editorial%20photography%20with%20clean%20composition%2C%20warm%20pastel%20tones%2C%20minimalist%20aesthetic&width=800&height=600&seq=mikami-article-01&orientation=landscape',
    publishedAt: '2024-07-15',
    readCount: 12850,
    tags: ['写真集', '2024', '冲绳', '夏季'],
  },
  {
    slug: 'new-drama-role-announcement',
    title: '三上悠亚确认出演秋季日剧《东京恋物语》女主角',
    summary: '三上悠亚正式宣布将主演TBS秋季日剧《东京恋物语》，这是她首次在黄金时段电视剧中担任女主角，饰演一位在东京打拼的年轻设计师。',
    content: `<p>TBS电视台今日正式宣布，三上悠亚将主演2024年秋季档日剧《东京恋物语》（東京恋物語），该剧将于10月起每周五晚10点播出。这是三上悠亚首次在黄金时段日剧中担任女主角。</p>
<p>《东京恋物语》讲述了来自地方城市的年轻设计师小川美咲（三上悠亚饰）在东京追逐梦想的故事。剧中，美咲在一家知名设计事务所工作，经历了职场挑战、友情考验和浪漫爱情，逐渐成长为一名独立自信的都市女性。</p>
<p>三上悠亚在发布会上表示："接到这个角色的时候，我真的非常激动。小川美咲这个角色身上有很多我自己的影子——我们都曾在陌生的城市里努力寻找自己的位置。我会尽全力演好这个角色，不辜负大家的期待。"</p>
<p>该剧的编剧由曾创作《东京爱情故事2020》的山田由美担任，导演则是执导过《深夜食堂》系列的松冈锭司。制作团队阵容强大，令人期待。</p>
<h3>播出信息</h3>
<ul>
<li>剧名：《东京恋物语》</li>
<li>电视台：TBS</li>
<li>播出时间：2024年10月起 每周五 22:00</li>
<li>主演：三上悠亚、佐藤健、吉冈里帆</li>
</ul>`,
    category: 'latest-news',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20TV%20drama%20press%20conference%20scene%20with%20elegant%20female%20lead%20in%20formal%20attire%20on%20stage%2C%20spotlight%20illumination%2C%20professional%20photography%2C%20clean%20minimalist%20backdrop%2C%20warm%20atmospheric%20lighting&width=800&height=600&seq=mikami-article-02&orientation=landscape',
    publishedAt: '2024-08-20',
    readCount: 9820,
    tags: ['日剧', '女主角', 'TBS', '秋季档'],
  },
  {
    slug: 'youtube-channel-1m-subscribers',
    title: '三上悠亚YouTube频道订阅突破100万，发布特别纪念影片',
    summary: '三上悠亚的个人YouTube频道订阅人数正式突破100万大关，她发布了一支特别的纪念影片感谢粉丝支持，并宣布将举办粉丝见面会。',
    content: `<p>三上悠亚的个人YouTube频道"Yua's Room"订阅人数于昨日正式突破100万大关！为庆祝这一里程碑，三上悠亚发布了一支长达30分钟的特别纪念影片，回顾了频道从创立至今的点点滴滴。</p>
<p>在纪念影片中，三上悠亚回顾了频道开设三年来的成长历程——从最初的化妆教程和日常Vlog，到后来的旅行纪录片、美食探店和粉丝Q&A。她哽咽着说："真的非常感谢每一位订阅者，是你们的支持让我能够坚持做自己喜欢的事情。100万不仅仅是一个数字，它代表着100万份信任和喜爱。"</p>
<p>影片的结尾，三上悠亚还宣布了一个重磅消息：为庆祝频道订阅突破100万，她将于今年12月在东京、大阪和名古屋三地举办粉丝见面会，届时将与粉丝近距离互动。</p>
<h3>粉丝见面会日程</h3>
<ul>
<li>东京场：2024年12月7日 东京国际论坛</li>
<li>大阪场：2024年12月14日 大阪城Hall</li>
<li>名古屋场：2024年12月21日 名古屋国际会议场</li>
</ul>`,
    category: 'fan-corner',
    coverImage: 'https://readdy.ai/api/search-image?query=YouTube%20content%20creator%20studio%20setup%20with%20warm%20ambient%20lighting%2C%20modern%20minimalist%20decor%2C%20ring%20light%2C%20camera%20equipment%2C%20cozy%20pastel%20color%20scheme%2C%20soft%20shadows%2C%20lifestyle%20photography&width=800&height=600&seq=mikami-article-03&orientation=landscape',
    publishedAt: '2024-09-05',
    readCount: 15630,
    tags: ['YouTube', '100万订阅', '粉丝见面会', '纪念'],
  },
  {
    slug: 'fashion-magazine-cover-october',
    title: '三上悠亚登《VOCE》10月号封面，畅谈美妆与时尚心得',
    summary: '三上悠亚登上日本知名美容杂志《VOCE》2024年10月号封面，在专访中分享了自己的护肤秘诀、日常妆容技巧以及对时尚的独到见解。',
    content: `<p>日本知名美容杂志《VOCE》2024年10月号于今日发行，三上悠亚以惊艳的秋季妆容登上封面。这是她第三次登上《VOCE》封面，展现了她在美容时尚领域日益增长的影响力。</p>
<p>本期杂志中，三上悠亚接受了长达10页的独家专访。她详细分享了自己的日常护肤流程："我每天早晚都会认真做好清洁、保湿和防晒这三步。在秋冬季节，我会特别注重保湿，使用的产品也会从清爽型换成滋润型。"</p>
<p>谈及妆容风格，三上悠亚表示："私下的我其实喜欢比较自然的妆容，但在工作时会根据场合调整。今年秋冬我很喜欢偏暖色调的眼妆，搭配奶茶色的唇妆，既温柔又有气质。"</p>
<p>杂志中还收录了多组三上悠亚演绎的秋季时尚穿搭，从通勤风到约会装，每一套都令人眼前一亮。</p>
<h3>杂志信息</h3>
<ul>
<li>杂志：《VOCE》2024年10月号</li>
<li>发行日期：2024年9月20日</li>
<li>定价：780日元</li>
<li>特典：三上悠亚双面海报</li>
</ul>`,
    category: 'latest-news',
    coverImage: 'https://readdy.ai/api/search-image?query=Fashion%20magazine%20cover%20photoshoot%20with%20elegant%20Japanese%20model%20in%20autumn%20makeup%20and%20stylish%20outfit%2C%20soft%20studio%20lighting%2C%20editorial%20aesthetic%2C%20warm%20beige%20and%20coral%20tones%2C%20high-end%20fashion%20photography&width=800&height=600&seq=mikami-article-04&orientation=landscape',
    publishedAt: '2024-09-20',
    readCount: 8720,
    tags: ['杂志', 'VOCE', '美妆', '时尚', '封面'],
  },
  {
    slug: 'tokyo-girls-collection-2024',
    title: '三上悠亚亮相Tokyo Girls Collection 2024秋冬秀场',
    summary: '三上悠亚作为特邀嘉宾亮相Tokyo Girls Collection 2024秋冬时装秀，身着知名设计师品牌礼服压轴走秀，成为全场焦点。',
    content: `<p>日本最大级别的时尚盛典——Tokyo Girls Collection（TGC）2024秋冬场于上周末在埼玉超级竞技场盛大举行。三上悠亚作为特邀嘉宾惊喜亮相，并担任了压轴走秀模特。</p>
<p>当晚，三上悠亚身着日本知名设计师品牌TADASHI SHOJI的定制礼服登场，一袭深酒红色的丝绒长裙搭配精致珠宝，尽显优雅气质。当她走上T台的那一刻，全场掌声雷动，闪光灯此起彼伏。</p>
<p>TGC制作人田中表示："邀请三上悠亚参加本次TGC是我们筹备已久的事情。她不仅拥有出众的外貌，更重要的是她积极努力的态度和对时尚的独到理解，完全符合TGC想要传达的理念。"</p>
<p>秀后，三上悠亚在社交媒体上分享了后台花絮照片，感谢设计师团队的精心打造，并表示这次的T台体验令她难忘。</p>`,
    category: 'latest-news',
    coverImage: 'https://readdy.ai/api/search-image?query=Fashion%20runway%20show%20with%20elegant%20model%20in%20dark%20wine%20red%20velvet%20evening%20gown%2C%20spotlight%20illumination%2C%20grand%20stage%20atmosphere%2C%20professional%20fashion%20event%20photography%2C%20dramatic%20lighting&width=800&height=600&seq=mikami-article-05&orientation=landscape',
    publishedAt: '2024-10-01',
    readCount: 11240,
    tags: ['TGC', '时装秀', '走秀', '时尚'],
  },
  {
    slug: 'charity-event-children-2024',
    title: '三上悠亚参与儿童慈善活动，捐赠1000万日元助力教育',
    summary: '三上悠亚出席"微笑儿童"慈善基金年度活动，个人捐赠1000万日元用于支持贫困地区儿童的教育事业，展现了偶像的社会责任感。',
    content: `<p>上周六，三上悠亚出席了由日本联合国儿童基金会（UNICEF Japan）主办的"微笑儿童"慈善基金年度活动。在活动现场，她宣布以个人名义捐赠1000万日元，用于支持日本及东南亚地区贫困儿童的教育项目。</p>
<p>三上悠亚在致辞中说道："每一个孩子都应该有追逐梦想的权利，而教育是通往梦想最重要的阶梯。我很荣幸能够通过自己的力量，为那些需要帮助的孩子们提供一些支持。"</p>
<p>除了捐款之外，三上悠亚还参与了现场的互动环节，与来自福利院的孩子们一起画画、做手工，场面温馨感人。活动结束后，她表示会将这份爱心持续下去，未来计划每年都参与类似的公益活动。</p>
<p>UNICEF Japan的代表对三上悠亚的慷慨捐赠表达了诚挚的感谢，称这笔资金将用于改善至少20所偏远地区学校的学习环境和教育资源。</p>`,
    category: 'latest-news',
    coverImage: 'https://readdy.ai/api/search-image?query=Charity%20event%20scene%20with%20warm%20atmosphere%2C%20people%20interacting%20with%20children%20in%20bright%20community%20space%2C%20soft%20natural%20light%20from%20windows%2C%20heartwarming%20documentary%20style%20photography%2C%20clean%20modern%20interior&width=800&height=600&seq=mikami-article-06&orientation=landscape',
    publishedAt: '2024-11-10',
    readCount: 7680,
    tags: ['慈善', 'UNICEF', '儿童', '公益'],
  },
  {
    slug: 'music-single-winter-ballad',
    title: '三上悠亚冬季抒情单曲《雪之华》MV公开，温柔嗓音感动听众',
    summary: '三上悠亚推出全新冬季抒情单曲《雪之华》，MV在北海道取景拍摄，唯美画面搭配温柔嗓音，发行首周即登上Oricon单曲榜前十。',
    content: `<p>三上悠亚的全新冬季抒情单曲《雪之华》（雪の華）于上周五正式发行，MV同步在YouTube公开。发行首周，该单曲便登上了Oricon单曲周榜第8位，创下了她个人音乐作品的最佳成绩。</p>
<p>《雪之华》是一首温暖而深情的冬季恋歌，由知名音乐制作人龟田诚治操刀制作。三上悠亚在录制时投入了大量情感，她透露："录音的时候，我一直在想象北海道的雪景和一段纯真美好的爱情故事，希望听众也能感受到那份温暖。"</p>
<p>MV在北海道的美瑛和富良野取景拍摄，白雪覆盖的丘陵、静谧的小木屋、温暖的炉火……每一个画面都充满了冬日童话般的氛围。MV上线48小时内便获得了超过200万次观看。</p>
<h3>单曲信息</h3>
<ul>
<li>曲名：《雪之华》</li>
<li>发行日期：2024年12月1日</li>
<li>制作人：龟田诚治</li>
<li>唱片公司：Sony Music Records</li>
</ul>`,
    category: 'works',
    coverImage: 'https://readdy.ai/api/search-image?query=Snowy%20winter%20landscape%20in%20Hokkaido%20with%20white%20snow-covered%20hills%20and%20cozy%20wooden%20cabin%2C%20soft%20diffused%20winter%20light%2C%20romantic%20atmosphere%2C%20cinematic%20composition%2C%20pastel%20cool%20tones%20with%20warm%20window%20glow&width=800&height=600&seq=mikami-article-07&orientation=landscape',
    publishedAt: '2024-12-01',
    readCount: 10230,
    tags: ['音乐', '单曲', 'MV', '冬季'],
  },
  {
    slug: '2025-new-year-greeting',
    title: '三上悠亚发表2025新年寄语：继续前行，不负期待',
    summary: '三上悠亚通过官方粉丝站发表2025年新年寄语，回顾了过去一年的成长与收获，并分享了新一年的工作计划和个人目标。',
    content: `<p>2025年新年伊始，三上悠亚通过官方粉丝站发表了温暖的新年寄语，向全球粉丝送上新年祝福，并分享了过去一年的心路历程和新一年的展望。</p>
<p>"2024年对我来说是充满挑战和成长的一年，"三上悠亚在寄语中写道，"从写真集的发行到首次主演日剧，从YouTube频道的成长到慈善活动的参与，每一步都离不开大家的支持。谢谢你们一直在我身边。"</p>
<p>谈到2025年的计划，三上悠亚透露将有更多影视作品与大家见面，同时也在筹备个人品牌的创立。"我希望能够不断突破自己，尝试更多不同的领域。无论走到哪里，我都不会忘记最初的那份初心——用自己的努力，给大家带来快乐和力量。"</p>
<p>新年寄语发布后，粉丝纷纷在评论区留言祝福，话题#三上悠亚2025新年寄语#迅速登上社交媒体热搜。</p>`,
    category: 'latest-news',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20New%20Year%20celebration%20scene%20with%20traditional%20kimono%2C%20warm%20golden%20lighting%2C%20elegant%20interior%20with%20seasonal%20decorations%2C%20soft%20focus%20background%2C%20festive%20yet%20minimalist%20aesthetic&width=800&height=600&seq=mikami-article-08&orientation=landscape',
    publishedAt: '2025-01-01',
    readCount: 18920,
    tags: ['新年', '寄语', '2025', '粉丝'],
  },
  {
    slug: 'behind-the-scenes-drama-filming',
    title: '独家幕后：三上悠亚《东京恋物语》拍摄花絮大公开',
    summary: '带您走进《东京恋物语》的拍摄现场，独家揭秘三上悠亚在片场的幕后故事，从凌晨化妆到深夜杀青的真实记录。',
    content: `<p>随着《东京恋物语》的热播，剧组今日公开了一组独家幕后花絮照片和视频，让粉丝得以一窥三上悠亚在片场的真实状态。</p>
<p>花絮中可以看到，三上悠亚每天凌晨5点便到达片场开始化妆准备，有时一天要连续拍摄12个小时以上。尽管如此，她在镜头前始终保持着专业的态度和灿烂的笑容。导演松冈锭司称赞道："三上悠亚是我见过最敬业的演员之一，她对每个细节都非常认真，经常主动要求和导演讨论角色的情感表达。"</p>
<p>其中一段花絮特别有趣——在拍摄一场吃拉面的戏份时，因为NG了多次，三上悠亚连续吃了5碗拉面，笑称自己"再也不想看到拉面了"。这些真实的幕后瞬间，让粉丝们感受到了偶像平凡而可爱的一面。</p>
<p>《东京恋物语》目前正在TBS热播中，收视率节节攀升，已成为本季最受关注的日剧之一。</p>`,
    category: 'interviews',
    coverImage: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20TV%20drama%20filming%20set%20with%20cameras%20and%20lighting%20equipment%2C%20warm%20atmospheric%20set%20lighting%2C%20professional%20crew%20working%2C%20cinematic%20documentary%20style%2C%20natural%20candid%20moments&width=800&height=600&seq=mikami-article-09&orientation=landscape',
    publishedAt: '2024-11-25',
    readCount: 9210,
    tags: ['幕后', '拍摄', '日剧', '花絮'],
  },
  {
    slug: 'early-life-and-debut-story',
    title: '从偶像团体到独立明星：三上悠亚的成长之路全记录',
    summary: '深度回顾三上悠亚从地方偶像团体起步，到成为日本顶级独立艺人的完整历程，记录下每一个重要的转折点和里程碑。',
    content: `<p>三上悠亚，1993年8月16日出生于日本爱知县名古屋市。她的演艺之路始于2010年，当时年仅17岁的她以偶像团体成员身份正式出道。团体时期的她虽然并非C位，但凭借甜美的笑容和扎实的舞蹈功底，逐渐积累了不少人气。</p>
<p>2015年是三上悠亚职业生涯的第一个转折点。她决定离开偶像团体，以个人身份重新出发。这个决定在当时被很多人认为是冒险的——毕竟，在日本娱乐圈，脱离团体单飞的偶像能成功的案例并不多。</p>
<p>"那段时间其实很煎熬，"三上悠亚在后来的采访中回忆道，"但我始终相信，只有真正做自己，才能走得更远。"</p>
<p>事实证明她的选择是正确的。单飞后的三上悠亚不仅在演艺事业上取得了更大的成功，还拓展了YouTube创作、时尚模特、歌手等多个领域。如今的她，已经成为日本娱乐圈最具影响力的多栖艺人之一。</p>
<h3>重要里程碑</h3>
<ul>
<li>2010年：以偶像团体成员身份出道</li>
<li>2015年：决定单飞，个人事业起步</li>
<li>2018年：首次主演电影《恋のしずく》</li>
<li>2019年：开设个人YouTube频道</li>
<li>2021年：发行首张个人音乐专辑</li>
<li>2024年：首次主演黄金时段日剧</li>
</ul>`,
    category: 'biography',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20city%20Nagoya%20skyline%20at%20sunset%20with%20warm%20golden%20light%2C%20modern%20urban%20aesthetic%2C%20reflective%20skyscraper%20windows%2C%20nostalgic%20atmosphere%2C%20clean%20composition%2C%20cinematic%20style&width=800&height=600&seq=mikami-article-10&orientation=landscape',
    publishedAt: '2024-08-16',
    readCount: 21050,
    tags: ['成长', '历程', '偶像', '传记'],
  },
];